import { Directive, ElementRef, HostListener } from "@angular/core";
import { NgControl } from '@angular/forms';

@Directive({
  selector: "[inputValueTrim]",
})

export class inputValueTrim {
    constructor(private el: ElementRef, private control: NgControl) {}

    @HostListener('blur', ['$event'])
    onBlur(event: KeyboardEvent) {
      this.trimText();
    }
    private trimText() {
      const value = this.el.nativeElement.value.trim();
      this.control.control?.setValue(value);
      this.control.control?.markAsTouched();
      this.control.control?.updateValueAndValidity();
    }
}
